import _axios from "../../index";

//获取列表
export const getSuite = () =>
    _axios({
        url: '/suiteConfig/search',
        method: "get",
    });

//获取待支付订单
export const getPendingPaymentOrder = () =>
    _axios({
        url: '/order/userPendingPaymentOrder',
        method: "get",
    });